import bjzx from "./bjzx.router";
import search from "./search.router";
import details from "./details.router";
import zgq from "./zgq.router";
import xsjh from "./xsjh.router";
import bkzx from "./bkzx.router";
import bkjx from "./bkjx.router";
import wssj from "./wssj.router";
import zwzx from "./zwzx.router";
import jgh from "./jgh.router";
import recommend from "./recommend.router";
import user from "./user.router";

import Home from "@/views/PCView/Home.vue"
export default [
  {
    path: "/",
    
    component: Home,
    redirect: "/index",
    children: [
      {
        path: "/index",
        name: "index",
        component:require("@/views/PCView/main/index").default
      },
      {
        path: "/about",
        name: "about",
        component: (resolve) => require(["@/views/PCView/about/index.vue"], resolve),
      },
      {
        path: "/mPAgreement",
        name: "agreement",
        component: (resolve) => require(["@/views/PCView/userAgreement/index.vue"], resolve)
      },
      {
        path: "/pagreement",
        name: "pagreement",
        component: (resolve) => require(["@/views/PCView/pAgreement/index.vue"], resolve)
      },
      {
        path: "/opinion",
        name: "opinion",
        component: (resolve) => require(["@/views/PCView/opinion/index.vue"], resolve),
      },
      {
        path: "/apptcp",
        name: "apptcp",
        component: (resolve) => require(["@/views/PCView/clause/index.vue"], resolve),
      },
      {
        path: "/zwsx",
        name: "zwsx",
        component: (resolve) => require(["@/views/PCView/zwsx/index.vue"], resolve),
      },
      {
        path: "/xszs",
        name: "xszs",
        component: (resolve) => require(["@/views/PCView/xszs/index.vue"], resolve),
      },
      {
        path: "/xszz",
        name: "xszz",
        component: (resolve) => require(["@/views/PCView/xszz/index.vue"], resolve),
      },
      {
        path: "/xshy",
        name: "xshy",
        component: (resolve) => require(["@/views/PCView/xshy/index.vue"], resolve),
      },
      {
        path: "/jypx",
        name: "jypx",
        component: (resolve) => require(["@/views/PCView/jypx/index.vue"], resolve),
      },
      { // 跳转百科中间页
        path: "/jumpdownload",
        name: "jumpdownload",
        meta: {
          title: '跳转下载应用',
        },
        component: resolve => require(["@/views/PCView/PCdownload/index.vue"], resolve),

      },
      { // 图书商城列表
        path: "/bookMall",
        name: "bookMall",
        meta: {
          title: '图书商城列表',
        },
        component: resolve => require(["@/views/PCView/PCdownload/SkipMobile.vue"], resolve),
      },
      { // 商品会议列表
        path: "/attendConference",
        name: "attendConference",
        meta: {
          title: '商品会议列表',
        },
        component: resolve => require(["@/views/PCView/PCdownload/SkipMobile.vue"], resolve),
      },
      { // 图书详情页
        path: "/bookDetails",
        name: "bookDetails",
        meta: {
          title: '图书详情页',
        },
        component: resolve => require(["@/views/PCView/PCdownload/SkipMobile.vue"], resolve),
      },


      ...details,
      ...zgq,
      ...xsjh,
      ...bjzx,
      ...bkzx,
      ...recommend,
      ...search,
      ...bkjx,
      ...zwzx,
      ...wssj,
      ...user,
      ...jgh,
      ,
      {
        path: '/:catchAll(.*)',
        name: 'not-found',
        component: resolve => require(["@/views/PCView/notFound.vue"], resolve),
      }
    ],
  },
];
